function Header() {
    return <header className="App-header">
    <h1 className="main-h1">Random Password Generator</h1>
  </header>;
}

export default Header;